// extracted by mini-css-extract-plugin
module.exports = {"root":"_1Bha0","bg":"_1I2VE"};